import React from 'react';
import { ChipTypeMap } from '@mui/material/Chip/Chip';
import { Chip, chipClasses } from '@mui/material';
import styled from '@emotion/styled';
import theme from 'src/theme';

export type Tag = { color: ChipTypeMap['props']['color']; text: string };
type Props = { tag: Tag };

const StyledChip = styled(Chip)(() => ({
  border: '1px solid',
  borderRadius: theme.spacing(2),
  whiteSpace: 'nowrap',
  cursor: 'unset',
  outline: 0,
  padding: 0,
  marginLeft: theme.spacing(1.5),
  fontSize: theme.spacing(1.25),
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.64px',
  height: theme.spacing(2),
  [`& .${chipClasses.label}`]: {
    paddingLeft: theme.spacing(0.6),
    paddingRight: theme.spacing(0.6),
  },
}));

const getChipColor = (color: ChipTypeMap['props']['color']) => {
  switch (color) {
    case 'success': {
      return {
        backgroundColor: 'rgba(198, 246, 217, 0.5)',
        color: '#1AA251',
      };
    }
    case 'info': {
      return {
        backgroundColor: 'rgba(229, 234, 242, 0.5)',
        color: 'rgb(67, 77, 91)',
      };
    }
    case 'primary':
    default: {
      return {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
      };
    }
  }
};

export const TagChip: React.FC<Props> = ({ tag }) => {
  return (
    <StyledChip
      size="small"
      label={tag.text}
      sx={{
        ...getChipColor(tag.color),
      }}
    />
  );
};
